import Report from 'modules/reports/models/Report'
import listReportsByUser from 'modules/reports/api/reports/listReportsByUser'
import useSearch, {useSearchContext} from 'modules/reports/hooks/search'
import ReportFolder from 'modules/reports/models/ReportFolder'

type Params = {
  userId: number
}

type Filters = {
  folder_id: number | 'all'
}

type Display = {
  density: 'compact' | 'comfortable'
}

function useReportsIndexPageSearch(userId: number) {
  const search = useSearch<Report, Params, Filters, Display>(listReportsByUser, {
    filters: {folder_id: 'all'},
    params: {userId},
    display: {density: 'comfortable'},
    sort: 'name',
  })

  return search
}

export default useReportsIndexPageSearch

export function useReportsIndexPageSearchContext() {
  const searchContext = useSearchContext<Report, Params, Filters, Display>()

  return {
    ...searchContext,
    folder: ReportFolder.safeCache(searchContext.filters.folder_id) as ReportFolder,
  }
}
